module.exports = __webpack_public_path__ + "img/TIQQE-logo-default-1024-300x53.4a9bbeb0.png";